/*
 * @Description: app下载
 * @Author: webJ
 */

import {
    mapState,
    mapActions,
} from 'vuex'
import viewName from '../constant.js'

export default {
    name: viewName.appDownload,
    components: {
    },
    data () {
        return {
            shareWxHint: false,
            device: 'other',
            downloadAppDialog: false
        }
    },
    computed: {
        ...mapState({
            isWeixin: ({ appInfo }) => appInfo.isWeixin // 是否是微信环境
        }),
    },
    created () {

    },
    activated () {

    },
    mounted () {
        if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
            this.device = 'ios'
        } else if (/(Android)/i.test(navigator.userAgent)) {
            this.device = 'android'
        }

        this.$emit('setHeader', {
            title: '枫车养车',
            showHeader: false
        })
        this.setAppClass({
            isAppend: false,
        })
    },
    methods: {
        ...mapActions([
            'getNearbySstores',
            'setAppClass'
        ]),
        /*
         * 开始下载app
         */
        onStartDownload () {
            if (this.device === 'ios') {
                window.location.href = 'https://itunes.apple.com/cn/app/id973762180'
            } else {
                window.location.href = 'http://www.carisok.com/app_release/iCar.apk'
            }
        },
        onDownload () {
            /* 如果是微信弹提示 */
            if (this.isWeixin) {
                this.shareWxHint = true
            } else {
                if (this.device === 'ios') {
                    window.location.href = 'www.carisok.com://icar'
                } else {
                    window.location.href = 'carisok://icar:8888/from'
                }
                setTimeout(() => {
                    this.downloadAppDialog = true
                }, 2000)
            }
        }
    },
    beforeDestroyed () {
        // this.$emit('setHeader', {
        //     showHeader: true
        // })
    },
}
